<template>
    <MainContainer :background="!smallOrLess ? 'lightGrey' : ''" :container="!smallOrLess">
        <CardShell :class="{'col-md-8 center mv4' : !smallOrLess}">

            <div class="ph3 ph4-m">
                <div class="flex items-center content-center">
                    <router-link class="absolute" to="/inbox">
                        <img class="w1" src="@/assets/img/icon_back_simple_yellow.svg"/>
                    </router-link>
                    <h4 class="center pv4 bg-white bb b--light-gray">{{contact.display_name}}</h4>
                </div>
            </div>

            <div class="bg-near-white pt4">
                <div class="mh2 mh4-m">
                    <Messages></Messages>               
                </div>
            </div>

            <SendMessage/>
            
        </CardShell>
    </MainContainer>
</template>

<script>
import Messages from '@/components/inbox/Messages.vue';
import MainContainer from '@/components/layout/MainContainer.vue';
import CardShell from '@/components/global/CardShell.vue';
import BackLink from '@/components/controls/BackLink.vue';
import SendMessage from '@/components/inbox/messagesCard/shared/SendMessage.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        Messages,
        MainContainer,
        CardShell,
        BackLink,
        SendMessage
    },
    computed: {
        ...mapGetters('messages', ['contact']),
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        }
    }
};
</script>
